/**
 * Register the service worker on app load.
 */

import { useEffect } from 'react';

export function useServiceWorker(): void {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          // Check for updates periodically
          reg.update().catch(() => { /* silent */ });
        })
        .catch((err) => {
          console.error('SW registration failed:', err);
        });
    }
  }, []);
}
